module.exports = __webpack_public_path__ + "img/jxpz.e920b524.png";